/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';

import { useSelect } from '../../../utils/selector.utils';
import { userSettingsPageSelectors } from '../../../app/page/page-storage/user-settings/user-settings.selectors';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { GoogleCalendarForm } from '../../pages/common/forms/GoogleCalendarForm';

export const GoogleCalendarDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const googleCalendarEmbedUrl = useSelect(userSettingsPageSelectors.selectGoogleCalendarEmbedUrl);

  const onClose = useCallback(() => {
    dispatch(closeDialog('googleCalendarEmbedUrlFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="googleCalendarEmbedUrlFormDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">Google Calendar</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <GoogleCalendarForm googleCalendarEmbedUrl={googleCalendarEmbedUrl} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="updateUserSettings" formName="googleCalendarEmbedUrl-form" text="Send" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
